import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled, { keyframes } from 'styled-components';

import { BrandS } from '@sorare/core/src/atoms/typography';
import { glossary } from '@sorare/core/src/lib/glossary';

const glow = keyframes`
    0% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
`;
const Root = styled.div`
  --animation-duration: 0.4s;
  position: relative;
  opacity: 0;
  transition: opacity var(--animation-duration);

  &.show {
    opacity: 1;
    &::after {
      content: '';
      display: block;
      position: absolute;
      inset: 0;
      opacity: 0;
      background: var(--c-nd-500);
      filter: blur(12px);
      animation: ${glow} calc(1.5 * var(--animation-duration)) ease-in-out;
    }
  }
`;

type Props = { show: boolean };
export const NewCardTag = ({ show }: Props) => {
  return (
    <Root className={classNames({ show })}>
      <BrandS color="var(--c-white)">
        <FormattedMessage {...glossary.new} />
      </BrandS>
    </Root>
  );
};
